// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getDemandas as listDemandasAPI,
    getDemanda as getDemandaAPI,
    addDemanda as addDemandaAPI,
    updateDemanda as updateDemandaAPI,
    deleteDemanda as deleteDemandaAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { demandasApiResponseError, demandasApiResponseSuccess } from './actions';
import { DemandasActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getDemanda({ payload: { id } }) {
    try {
        const response = yield call(getDemandaAPI, id );
        const demandaItem = response.data.data;
        yield put(demandasApiResponseSuccess(DemandasActionTypes.GET_DEMANDA, demandaItem));
    } catch (error) {
        yield put(demandasApiResponseError(DemandasActionTypes.GET_DEMANDA, error));
    }
}

function* addDemanda({payload:demanda}){
    try{
        const response = yield call(addDemandaAPI,{...demanda})
        const demandaItem = response.data.data
        yield put(demandasApiResponseSuccess(DemandasActionTypes.ADD_DEMANDA,demandaItem))
    } catch(error){
        yield put(demandasApiResponseError(DemandasActionTypes.ADD_DEMANDA,error))
    }
}

function* updateDemanda({payload:demanda}){
    try{
        const response = yield call(updateDemandaAPI,{...demanda})
        const demandaItem = response.data.data
        yield put(demandasApiResponseSuccess(DemandasActionTypes.UPDATE_DEMANDA,demandaItem))
    }catch(error){
        yield put(demandasApiResponseError(DemandasActionTypes.UPDATE_DEMANDA,error))
    }
}
function* deleteDemanda({payload:{id}}){
    try{
        const response = yield call(deleteDemandaAPI,id)
        const demandaItem = response.data.id
        yield put(demandasApiResponseSuccess(DemandasActionTypes.DELETE_DEMANDA,demandaItem))
    }catch(error){
        yield put(demandasApiResponseError(DemandasActionTypes.DELETE_DEMANDA,error))
    }
}

function* listDemandas({payload:params}) {
    try {
        const response = yield call(listDemandasAPI, { ...params });
        const listaDemandas = response.data.data;
        yield put(demandasApiResponseSuccess(DemandasActionTypes.LIST_DEMANDAS, listaDemandas));
    } catch (error) {
        yield put(demandasApiResponseError(DemandasActionTypes.LIST_DEMANDAS, error));
    }
}

export function* watchGetDemanda(): any {
    yield takeEvery(DemandasActionTypes.GET_DEMANDA, getDemanda);
}
export function* watchListDemandas(): any {
    yield takeEvery(DemandasActionTypes.LIST_DEMANDAS, listDemandas);
}

export function* watchAddDemanda():any{
    yield takeEvery(DemandasActionTypes.ADD_DEMANDA,addDemanda)
}
export function* watchUpdateDemanda():any{
    yield takeEvery(DemandasActionTypes.UPDATE_DEMANDA,updateDemanda)
}
export function* watchDeleteDemanda():any{
    yield takeEvery(DemandasActionTypes.DELETE_DEMANDA,deleteDemanda)
}


function* demandasSaga(): any {
    yield all([
        fork(watchGetDemanda),
        fork(watchListDemandas),
        fork(watchAddDemanda),
        fork(watchUpdateDemanda),
        fork(watchDeleteDemanda),
    ]);
}

export default demandasSaga;
